export default "__VITE_ASSET__CPHiBifC__"